/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) return;

    this.landing = this.container.querySelector('#search-drawer-landing');
    this.searchWrapper = this.container.querySelector('#search-drawer-search-wrapper');
    this.searchToggle = this.container.querySelector('#search-drawer-search-toggle');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  showLanding() {
    if (this.landing) this.landing.removeAttribute('hidden');
    if (this.searchWrapper) this.searchWrapper.setAttribute('hidden', '');
    if (this.predictiveSearchResults) this.predictiveSearchResults.classList.remove('active');
    if (this.input) this.input.value = '';
  }

  showSearch() {
    if (this.landing) this.landing.setAttribute('hidden', '');
    if (this.searchWrapper) this.searchWrapper.removeAttribute('hidden');
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (this.input) this.input.focus({ preventScroll: true });
      }, 50);
    });
  }

  setupEventListeners() {
    if (this.form) this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    if (this.input) {
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }

    if (this.searchToggle) {
      this.searchToggle.addEventListener('click', () => {
        this.showSearch();
        dispatchCustomEvent('search:open');
      });
    }

    this.button.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpening = !this.container.classList.contains('active');
        const isTipFinder = item.classList.contains('comply-tip-finder');
        document.body.classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (isOpening) {
          this.showLanding();
          dispatchCustomEvent('search:open');
          if (isTipFinder) {
            const tipFinderBtn = this.container.querySelector('.search-drawer-tip-finder-btn');
            if (tipFinderBtn) {
              setTimeout(() => tipFinderBtn.click(), 100);
            }
          }
        }
        return false;
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      if (this.predictiveSearchResults) this.predictiveSearchResults.classList.remove('active');
      return;
    }
    if (this.predictiveSearchResults) this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    if (!this.predictiveSearchResults) return;

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchResults) return;

    this.predictiveSearchResults.innerHTML = resultsMarkup;

    const submitButton = this.container.querySelector('#search-results-submit');
    if (submitButton && this.form) {
      submitButton.addEventListener('click', () => this.form.submit());
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});